import {Action} from '@ngrx/store';
import { UserId } from 'src/shared/models/user';

export const USER_LOGGED_IN = '[User] logged in';
export const USER_LOGGED_OUT = '[User] logged out';

export class UserLoggedIn implements Action {
  readonly type = USER_LOGGED_IN;

  constructor(
    public displayName: string,
    public userId: UserId,
    public username: string,
    public bearerToken: string,
    public totpLocked: boolean,
  ) {
  }
}

export class UserLoggedOut implements Action {
  readonly type = USER_LOGGED_OUT;

  constructor() {
  }
}

export type Actions = UserLoggedIn | UserLoggedOut;
